import { Pipe, PipeTransform } from '@angular/core';
import { PerformerEntity } from '../../entities/performer.entity';

@Pipe({ name: 'usersName' })
export class UsersNamePipe implements PipeTransform {
    constructor() { }
    transform(users: PerformerEntity[], defaultVal = ''): string {
        let r = '';
        users.forEach(u => {
            r += u.performerName + '，';
        });
        if (r) {
            r = r.substring(0, r.length - 1);
        }
        return r ? r : defaultVal;
    }
}
@Pipe({ name: 'usersId' })
export class UsersIdPipe implements PipeTransform {
    constructor() { }
    transform(users: PerformerEntity[], defaultVal = ''): string {
        let r = '';
        users.forEach(u => {
            r += u.performerId + ',';
        });
        if (r) {
            r = r.substring(0, r.length - 1);
        }
        return r ? r : defaultVal;
    }
}
